export default "__VITE_ASSET__BfdYnSqU__"